import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AttributeWrite } from '../models/attributes/attributeWrite';
import { ComplexAttributeWrite } from '../models/attributes/complexAttributeWrite';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldEditorService {
  public readonly update = new Subject<{
    isComplexField: boolean;
    attributeWriter: AttributeWrite;
    complexAttributeWriters: ComplexAttributeWrite[];
  }>();
  public readonly clear = new Subject<string>();

  constructor() {}
}
